/** @jsxImportSource @emotion/react */
import { colors, Container, Divider, HeadingH2, HeadingH3, Section } from 'components/landing/ui';

import dots from '../../images/dots.svg';
import arrow from '../../images/s1-arrow.svg';
import bg1x from '../../images/s2-bg-1x.png';
import bg2x from '../../images/s2-bg-2x.png';
import bg3x from '../../images/s2-bg-3x.png';
import GuaranteedResult from '../../ui/guaranteed-result';
import RightCol from './right-col';

const S2 = () => (
  <Container>
    <Section
      css={{
        paddingTop: 50,
        '@media (min-width:992px)': { paddingTop: 100 },
        '@media (min-width:1366px)': { paddingTop: 120 },
      }}
    >
      <div
        css={{
          position: 'relative',
          flexDirection: 'column',
          width: '100%',
          marginBottom: 30,
          '@media (min-width:992px)': { marginBottom: 50 },
          alignItems: 'center',
          textAlign: 'center',
          zIndex: 1,
        }}
      >
        <HeadingH2 css={{ marginBottom: 5 }}>попробуйте НАШ СЕРВИС БЕСПЛАТНО</HeadingH2>
        <HeadingH3 css={{ color: colors.grayLight }}>
          И получи первых клиентов уже сегодня
        </HeadingH3>

        <div
          css={{
            position: 'absolute',
            display: 'none !important',
            left: 0,
            background: `url(${dots})`,
            height: 256,
            width: 284,

            '@media (min-width:768px)': { display: 'block !important' },
            '@media (min-width:1366px)': { width: 362 },
          }}
        />

        <img
          src={arrow}
          css={{
            position: 'absolute',
            display: 'none',
            opacity: 0.35,
            transform: 'scaleX(-1)',
            '@media (min-width:992px)': { display: 'block', top: -18, left: 16, width: 141 },
            '@media (min-width:1366px)': {
              top: -60,
              left: 80,
              width: 221,
              transform: 'scaleX(-1) rotate(-20deg)',
            },
          }}
        />
      </div>

      <div
        css={{
          '>div:nth-of-type(1)': {
            flexBasis: '62%',
            flexShrink: 1,
            marginBottom: 30,
            '@media (min-width:992px)': { marginRight: 50, marginBottom: 0 },
          },
          '>div:nth-of-type(2)': {
            flexBasis: '38%',
            flexShrink: 1,
          },
          '@media (min-width:992px)': { flexDirection: 'row', paddingBottom: 40 },
          flexDirection: 'column',
          paddingBottom: 30,
          zIndex: 2,
          width: '100%',
        }}
      >
        <div>
          <img srcSet={`${bg1x} 1x, ${bg2x} 2x, ${bg3x} 3x`} css={{ width: '100%' }} />
        </div>

        <RightCol />
      </div>

      <GuaranteedResult>Пользуясь ВК-БОСС вы гарантированно получите результат</GuaranteedResult>

      <Divider
        css={{
          marginTop: 50,
          '@media (min-width:992px)': { marginTop: 130 },
          '@media (min-width:1366px)': { marginTop: 120 },
        }}
      />
    </Section>
  </Container>
);

export default S2;
